import { takeLatest, call } from 'redux-saga/effects'
import axios from 'axios'
import apiConfig from '@services/apiConfig'
import errorHandler from '../errorHandler'
import { GET_ROOMS_ACTION } from '@stores/actions/room'

// eslint-disable-next-line no-console
const dbg = (...a) => console.debug('[saga][rooms]', ...a)

function* getRoomsWorker({ callback }) {
  try {
    dbg('GET', `${apiConfig.prefix}/room/findAllRoom`)
    const res = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/room/findAllRoom`,
    })
    callback && callback(res.data || [])
  } catch (err) {
    callback && callback([])
    errorHandler(err)
  }
}

export function* getRoomsSaga() {
  // eslint-disable-next-line no-console
  console.debug('[saga][rooms] watcher online')
  yield takeLatest(GET_ROOMS_ACTION, getRoomsWorker)
}
